// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9zWMh","left":"styles_left__22B6X"};